import htmlIcon from '/assets/htm_icon.svg'
import cssIcon from '/assets/css_icon.svg'
import jsIcon from '/assets/js_icon.svg'
import reactIcon from '/assets/react_icon.svg'
import tsIcon from '/assets/typescript.svg'
import tailwindcssIcon from '/assets/tailwindcss.svg'
import firebaseIcon from '/assets/firebase.svg'
import gitHubIcon from '/assets/gitubIcon.svg'
import sqlIcon from '/assets/Sql.svg'
import apiIcon from '/assets/rest-api_icon.svg'
import nodeIcon from '/assets/nodejs_icon.svg'
import phpIcon from '/assets/php_icon.svg'


export const IconData = [
  {
    index: 0,
    icon: reactIcon,
    name: 'React',
    level: 90,
    category: 'frontend'
  },
  {
    index: 1,
    icon: jsIcon,
    name: 'JavaScript',
    level: 90,
    category: 'frontend'
  },
  {
    index: 2,
    icon: tsIcon,
    name: 'TypeScript',
    level: 65,
    category: 'frontend'
  },
  {
    index: 3,
    icon: htmlIcon,
    name: 'HTML5',
    level: 95,
    category: 'frontend'
  },
  {
    index: 4,
    icon: cssIcon,
    name: 'CSS3',
    level: 90,
    category: 'frontend'
  },
  {
    index: 5,
    icon: tailwindcssIcon,
    name: 'Tailwind CSS',
    level: 80,
    category: 'frontend',
    secondary: true
  },
  {
    index: 6,
    icon: nodeIcon,
    name: 'Node.js',
    level: 70,
    category: 'backend'
  },
  {
    index: 11,
    icon: phpIcon,
    name: 'PHP',
    level: 75,
    category: 'backend'
  },
  {
    index: 7,
    icon: apiIcon,
    name: 'REST API',
    level: 75,
    category: 'backend'
  },
  {
    index: 9,
    icon: sqlIcon,
    name: 'SQL',
    level: 65,
    category: 'backend'
  },
  {
    index: 8,
    icon: firebaseIcon,
    name: 'Firebase',
    level: 60,
    category: 'backend',
    secondary: true
  },
  {
    index: 10,
    icon: gitHubIcon,
    name: 'Git',
    level: 80,
    category: 'fullstack'
  }
]
